import React from "react";
import { Autocomplete, Box, Stack, TextField } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const LocationMissingToolbar = ({
  dateFrom,
  onDateFromChange,
  uploaderOptions = [],
  uploadedByKey,
  onUploadedByKeyChange,
}) => (
  <Stack
    direction={{ xs: "column", md: "row" }}
    spacing={2}
    sx={{ mb: 2 }}
    alignItems={{ md: "center" }}
  >
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label="Added since"
        value={dateFrom ? dayjs(dateFrom) : null}
        onChange={(value) => {
          onDateFromChange(value ? value.startOf("day").toISOString() : "");
        }}
        slotProps={{
          textField: {
            size: "small",
            sx: { minWidth: 220 },
          },
        }}
      />
    </LocalizationProvider>

    <Autocomplete
      size="small"
      sx={{ minWidth: 280, flex: 1, maxWidth: 420 }}
      options={uploaderOptions}
      value={uploaderOptions.find((option) => option.value === uploadedByKey) || null}
      onChange={(_, option) => {
        onUploadedByKeyChange(option?.value || "");
      }}
      getOptionLabel={(option) => option?.label || ""}
      isOptionEqualToValue={(option, value) => option?.value === value?.value}
      renderInput={(params) => (
        <TextField {...params} label="Uploaded by" placeholder="Filter by uploader" />
      )}
    />

    <Box sx={{ fontSize: "0.85rem", color: "text.secondary" }}>
      Showing price history rows whose source image is missing EXIF GPS.
    </Box>
  </Stack>
);

export default LocationMissingToolbar;
